module.exports = __webpack_public_path__ + "static/media/featuredCOLLECTIVIBE.f1113bc3.jpg";